import type * as React from 'react';
import { get } from '@Domain/Api';
import grantableUsersFound, {
	type GrantableUsersFoundAction,
} from '@Application/SubjectTypeDefinitions/Actions/grantableUsersFound';
import grantableUsersSearchFailed, {
	type GrantableUsersSearchFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/grantableUsersSearchFailed';
import type SearchGrantableUsers from '@Application/SubjectTypeDefinitions/Queries/SearchGrantableUsers';
import type { UsersListFetchedPayload } from '@Application/Users/Users/Actions/usersFetched';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = GrantableUsersFoundAction | GrantableUsersSearchFailedAction;

/**
 * Searches the active users of the account a type can be granted to. Writes to
 * `subjectTypeDefinitionsStore.userCandidates`, never to `usersStore` (owned by the Users screen).
 */
export default (query: SearchGrantableUsers) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const { results } = await get<UsersListFetchedPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/users?${query.toQueryString()}`,
			);

			const action = grantableUsersFound(
				results.map(({ id, firstName, lastName }) => ({ id, firstName, lastName })),
				query.accountId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = grantableUsersSearchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
